import axios from 'axios'
import store from '../store'

/** Instancia axios */
export const http = axios.create({
  baseURL: process.env.VUE_APP_HOST,
  headers: {
    'Content-Type': 'application/json'
  }
})
/** 
 * Se crea interceptor para el header
 * Asigna parametro 'Authorization' si se cuenta con token
 * Se asigna parametro 'timezone'al header para obtener la zona horaria en formato IANA time zone
*/
http.interceptors.request.use(
  config => {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    config.headers = {
      ...config.headers,
      'X-timezone': timezone
    }
    if (store.state.userState) {
      config.headers.Authorization = `Bearer ${store.state.userState.access_token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)